module.exports = {
  Invalid20: 'Цена продажи 20-футового контейнера не может быть ниже себестоимости.',
  Invalid40: 'Цена продажи 40-футового контейнера не может быть ниже себестоимости.',
  Invalid45: 'Цена продажи 45-футового контейнера не может быть ниже себестоимости.',
  ALL: '【Все】',
  ALLINIncludes: 'Комиссия ALL IN включает следующие дополнительные сборы:',
  ALLINRemarks: 'Примечание: цена ALL IN включает пункты с серым фоном в дополнительных сборах.',
  ALLRG: '【Все】',
  AbnormalDetected: 'Уважаемый, согласно правилам проверки системы, обнаружены возможные проблемы с тарифами на проверке. Для подробностей нажмите на синий заголовок.',
  Accept: 'Принять',
  AcceptTenant: 'Получатель',
  AcceptTime: 'Дата принятия',
  AcceptUser: 'Принявший',
  Accepted: 'Принято',
  Add: 'Добавить',
  AddCondition: 'Добавить условие проверки',
  AddFee: 'Добавить дополнительный сбор',
  AddNewCustomer: 'Добавить нового клиента',
  Address: 'Адрес',
  Agent: 'Агент',
  Agree: 'Одобрить заявку',
  CancelAgree: 'Отозвать согласие',
  Canceled: 'Отозвано',
  Agreed: 'Согласовано',
  Air: 'Авиаперевозка',
  AirStatistics: 'Статистика авиатарифов',
  Aircraft: 'Тип самолета',
  AircraftFullName: 'Полное название типа самолета',
  Airliner: 'Пассажирский самолет',
  AlertEQAbnormal: 'Уведомлять при следующих ситуациях в сравнении цен разных типов контейнеров при одинаковых условиях',
  AlertPlaceAbnormal: 'Уведомлять при следующих ситуациях в сравнении цен одинаковых типов контейнеров с одинаковыми POL и POD',
  AlertSumAbnormal: 'Уведомлять при следующих ситуациях с общей стоимостью тарифа',
  AlertValidAbnormal: 'Уведомлять при следующих ситуациях со сроком действия тарифа',
  AllState: '【Все】',
  AllowedTier: 'Разрешенный уровень просмотра:',
  Amount: 'Сборы',
  Approve: 'Проверка',
  ApproveAsync: 'Запускать задачу проверки в фоновом режиме?',
  TariffRatingAtTheTimeOfMaintenance: 'Определить уровень тарифа',
  ApproveSet: 'Настройки проверки',
  ApprovedBy: 'Проверяющий',
  ApprovedDate: 'Дата проверки',
  Attachment: 'Вложение',
  Audit: 'Проверка',
  AuthAccept: 'Общее с другими',
  AuthInvite: 'Поделиться с другими',
  AuthInvite2: 'Общий доступ к тарифам',
  AuthAccept2: 'Подписка на тарифы',
  AuthorizedClient: 'Доверенная организация',
  BOTH_EMPTY: '{0} Строки, {1} и {2} Запишите хотя бы один пункт; \n',
  Back: 'Назад',
  BadDays: 'Неверный формат маршрута!',
  BasicInfo: 'Основная информация',
  ECommerceEta: 'Электронная ETA',
  ECommerceEtd: 'Электронная ETD',
  BasicPort: 'Базовый порт',
  BeginDate: 'Срок действия',
  BeginDateCol: 'Действительно с',
  Big: 'Увеличить',
  BillType: 'Тип коносамента',
  BookingAgent: 'Агент по бронированию',
  Both: 'Предоплата и оплата при получении по одной цене',
  Branch: 'Филиал',
  BusinessType: 'Тип операции',
  ByDate: 'По времени',
  ByPort: 'По порту',
  ByState: 'По статусу',
  CANCEL: 'Отмена',
  CHARGES: '{0} Строка, тип ящика {2} {1} Дополнительная плата вводится неправильно; \n',
  COD: 'Страна (регион) назначения',
  CODPrompt: 'Введите страну или регион разгрузки',
  CODAirPrompt: 'Введите страну или регион назначения',
  COL: 'Страна (регион) отправления',
  COLPrompt: 'Введите страну или регион отправления',
  COMMON_ERROR: 'Строка {0}, {1} неверно;<br/>',
  CONFIRM: 'Подтвердить',
  COST_VAT: 'Налоговая ставка на себестоимость',
  CabinNature: 'Характер места',
  CabinState: 'Статус места',
  Cancel: 'Отмена',
  CargoAircraft: 'Грузовой самолет',
  Carrier: 'Судоходная компания',
  Carrier_Air: 'Авиакомпания',
  CasePriceInvalid: 'Цена продажи за единицу не может быть меньше себестоимости.',
  ChargeName: 'Наименование расхода',
  ChargeOfDeliveryPlace: 'Расходы на месте доставки',
  ChargeOfReceiptPlace: 'Расходы на месте получения',
  ChargeType: 'Тип расхода',
  ChargeUnit: 'Единица расчета',
  ChargedWeight: 'Расчетный вес',
  Check: 'Проверить',
  CheckApproveSet: 'Настройка тайм-аута проверки',
  CheckInterval: 'Интервал опроса',
  ChineseName: 'Китайское название',
  Chk: '【Флажок】',
  City: 'Город',
  ClickMe: 'Нажмите для переключения режима запроса.',
  ClickMeSimple: 'Нажмите для переключения режима запроса. Срок действия тарифа по умолчанию для простого способа запроса начинается сегодня, и для получения информации о других тарифах срока действия перейдите в расширенный запрос.',
  Client: 'Клиент',
  ClientExist: 'Имя клиента уже существует в системе!',
  ClientIsEmpty: 'Уполномоченная организация не может быть пустой.',
  ClientName: 'Название клиента',
  Close: 'Закрыть',
  ClosingDay: 'Дата закрытия',
  Code: 'Код',
  Collect: 'Оплата при получении',
  Coloader: 'Коллега',
  ColoaderMin: 'Коллега (мин.)',
  ColoaderPrice: 'Цена для коллег',
  ColoaderRate: 'Коллега (ставка)',
  ColumnName: 'Название столбца',
  Commodity: 'Груз',
  Common: 'Обычный груз',
  CompareTime: 'Время начала должно быть меньше времени окончания!',
  CompareValidate: 'Время окончания срока действия должно быть больше времени начала!',
  FreeTimeType: 'Тип бесплатного контейнерного периода',
  PleaseInput: 'Пожалуйста, введите значение {0}.',
  NeedFreeBox: 'Бесплатное использование контейнера {0} дней (смешанное)',
  FreeTimeCalculatedSeparately: 'Бесплатный складской период {0} дней, бесплатное использование контейнера {1} дней',
  Contact: 'Контактное лицо',
  ContinueApprove: 'Продолжить проверку',
  ContractNo: 'Номер договора',
  Copy: 'Копировать',
  CopyPriceNo: 'Копировать номер',
  CopyQuotation: 'Копировать предложение',
  CopySetting: 'Копировать конфигурацию',
  Cost: 'Себестоимость',
  Cost20: 'Себестоимость 20\'',
  Cost40: 'Себестоимость 40\'',
  Cost45: 'Себестоимость 45\'',
  CostHC: 'Себестоимость 40\'HC',
  CostMin: 'Себестоимость (мин.)',
  CostPrice: 'Цена себестоимости',
  CostRate: 'Себестоимость (ставка)',
  Country: 'Страна',
  CountryPrompt: 'Пожалуйста, введите страну или регион отправления',
  CreatedBy: 'Внесший данные',
  CreatedDate: 'Дата создания',
  Currency: 'Валюта',
  CurrentPrice: 'Опубликовано',
  CurrentPriceEditSucceed: 'Изменение опубликованного тарифа успешно, его статус автоматически изменился на тариф, ожидающий проверки, вам необходимо повторно утвердить.',
  CurrentTenant: 'Наша компания',
  CustomConfig: 'Настроить...',
  CustomerMin: 'Прямой клиент (мин.)',
  CustomerPrice: 'Цена для прямого клиента',
  CustomerRate: 'Прямой клиент (ставка)',
  CyCy: 'CY-CY',
  CyDoor: 'CY-DOOR',
  CyRamp: 'CY-RAMP',
  Dangerous: 'Опасный груз',
  DangerousClass: 'Класс опасного груза',
  DataGridConfig: 'Настраиваемые столбцы отображения',
  Day: 'День',
  Days: 'Маршрут',
  DaysColSea: 'Продолжительность маршрута (дни)',
  DaysUnitSea: 'Продолжительность маршрута (дни)',
  DaysValidate: 'Поле "Маршрут" не может быть пустым.',
  DecodeMarkupFailed: 'Ошибка анализа конфигурации проверки тарифов!',
  DelFee: 'Удалить эту надбавку',
  DelRate: 'Удалить тариф',
  Delete: 'Удалить',
  DeleteCfg: 'Удалить этот элемент конфигурации',
  DepartureDay: 'Расписание судов',
  DepartureDay2: 'Расписание судов 2',
  DepartureDayOfAir: 'Расписание рейсов',
  DepartureDayOfAir2: 'Расписание второго рейса',
  CargoAircraft2: 'Грузовой самолет второго рейса',
  AircraftOrFreighter: 'Пассажирский/грузовой самолет',
  FreighterOrAircraft: 'Грузовой/пассажирский самолет',
  AirlinerNB: 'Пассажирский самолет (NB)',
  DesCharge: 'Плата за пункт назначения',
  Dest: 'Порт выгрузки',
  DestinationDock: 'Причал в порту назначения',
  Detail: '【Подробности】',
  DetailOfFCL: 'Подробности тарифа FCL',
  DetailOfLCL: 'Подробности тарифа LCL',
  Details: 'Подробности',
  DifferentCarrier: 'Проверяемые тарифы принадлежат нескольким судоходным компаниям. Продолжить?',
  DifferentCarrierAndRegion: 'Проверяемые тарифы принадлежат нескольким судоходным компаниям и {0}. Продолжить?',
  DifferentCarrierAndRegions: 'Проверяемые тарифы принадлежат нескольким судоходным компаниям, регионам отправления и выгрузки. Продолжить?',
  DifferentPOD: 'Выбранные цены имеют разные порты выгрузки. Продолжить?',
  DifferentPOL: 'Выбранные цены имеют разные порты отправления. Продолжить?',
  DifferentRegion: 'Проверяемые тарифы принадлежат нескольким {0}. Продолжить?',
  Direct: 'Прямой',
  DirectCustomer: 'Прямой клиент',
  Dock: 'Причал захода',
  Dockland: 'Портовая зона',
  DocumentCategory: 'Тип документа',
  DocumentId: 'Исходный номер документа для импорта',
  DuplicateFees: 'Надбавка {0} повторяется!',
  DuplicateShare: 'Вы уже поделились тарифами с {0}, повторное действие не требуется.',
  EMPTY_DATATABLE: 'Сервер не имеет соответствующих данных {0}, свяжитесь с системным администратором; \n',
  EQAbnormal: 'Обнаружены аномалии при сравнении цен на разные типы контейнеров в одинаковых условиях;',
  EQMustDifferent: 'Типы контейнеров не могут быть одинаковыми',
  EQ_TYPE_SIZE: 'Строка и тип ячейки {1}, указанный {0}, неверны; \n',
  EXISTS_SAME_TIME: '{0} строки, {1} и {2} не могут быть введены одновременно; \n',
  EXISTS_SAME_TIME2: 'Поля {0} и {1} не могут быть заполнены одновременно.',
  Edit: 'Редактировать',
  EffectiveDate: 'Дата вступления в силу',
  EffectiveDateType: 'Тип даты вступления в силу',
  Email: 'Электронная почта',
  EndDate: 'до',
  EndDateAlign: 'право',
  EndDateCol: 'Дата окончания срока действия',
  EndTime: 'Время окончания',
  EnglishName: 'Английское название',
  EqSize: 'Тип контейнера',
  EqType: 'Вид контейнера',
  Error: 'Ошибка',
  ErrorCfg: 'Обнаружена ошибка в конфигурации, пожалуйста, проверьте.',
  ErrorRaised: 'Произошла ошибка.',
  ExceedMaxAmount: 'При отсутствии фонового режима проверки программа может обрабатывать максимум 300 записей за раз.',
  ExistLoop: 'Обнаружена циклическая настройка',
  ExpirationDate: 'Дата истечения срока',
  ExpirationDateType: 'Тип даты истечения срока',
  Export: 'Экспорт в Excel',
  ExportByTemplate: 'Экспорт по шаблону',
  ExportMode: 'Выберите способ экспорта тарифных данных',
  ExportPDF: 'Экспорт в PDF',
  ExtraInfo: 'Дополнительная информация',
  ExtraLoadFailed: 'Ошибка загрузки дополнительной информации!',
  FCL: 'Полная загрузка контейнера (FCL)',
  FCLStatistics: 'Статистика тарифов FCL',
  FIELD_TOO_LONG: '{0} строки, {1} длина слишком длинная, максимально допустимая длина {2}; \n',
  FORMAT_NOT_MATCHING: '{0} Строка, {1} Формат неправильный; \n',
  Fair: 'Без изменений',
  Fall: 'Снижение',
  FaultCode: 'Код ошибки:',
  FaultMessage: 'Сообщение:',
  Fax: 'Факс',
  FeeFclPrompt: 'Введите краткое название расхода',
  FeeIndex: 'Порядковый номер',
  FeeMin: 'Расходы (Min)',
  FeeName: 'Наименование расхода',
  FeeNameIsNull: 'Введите название расхода.',
  FeeRate: 'Расходы (Ставка)',
  FeeUnit: 'Единица тарификации',
  FeeUnitIsNull: 'Введите единицу тарификации.',
  Fees: 'Расходы',
  FileHistory: 'История файлов',
  FileName: 'Имя документа',
  FileSize: 'Размер документа',
  Find: 'Поиск',
  Finished: 'Операция завершена.',
  Flight: 'Сервисные услуги',
  FreeTime: 'Бесплатный период аренды контейнера',
  FreightTerm: 'Условия перевозки',
  Fri: 'Пятница',
  Friday: 'Пятница',
  GenerateCharge: 'Генерация расходов при бронировании',
  Goods: 'Наименование товара',
  GoodsLevel: 'Уровень',
  GreaterThanZero: 'Значение должно быть больше 0!',
  GroupNo: 'Номер группы',
  HCInvalid: 'Цена продажи 40\'HC не может быть ниже себестоимости.',
  HasApproved: 'Проверено.',
  HasDeleted: 'Удалено.',
  Hazard: 'Опасный груз',
  HeadLiftAircraft: 'Первый рейс пассажирского самолета',
  HiddenCost: 'Нельзя просматривать себестоимость других филиалов.',
  Hour: 'Час',
  Hours: 'Часы',
  IS_EMPTY: '{0} Строка, {1} не может быть пустой; \n',
  EXIST_THE_SAME_TIME: '{0} строки, {1} и {2} количество отличается; \n',
  IS_LESS: '{0} строка, {1} не может быть меньше {2}; \n',
  IS_SAME: '{0} строка, {1} не может быть такой же, как {2}; \n',
  IWantShare: 'Я хочу поделиться тарифами с',
  Import: 'Импорт из Excel',
  GeekYumImport: 'Импорт тарифов Jiyu',
  OneStackImport: 'Импорт тарифов Yida',
  InactiveRate: 'Цены с зачеркнутым номером недействительны!',
  InputValue: 'Пожалуйста, введите!',
  Invalid: 'Недействительно',
  InvalidSelection: 'Установить выбранные данные как недействительные?',
  InviteTenant: 'Приглашающая сторона',
  InviteUser: 'Приглашающий',
  IsActive: 'Активировать?',
  IsAllowedOperate: 'У вас нет прав на проверку или удаление тарифов с портом отправления {0} и портом выгрузки {1}!',
  IsAllowedOperate_DiffBranch: 'Вы не можете изменять тарифы, введенные другими филиалами!',
  IsApproveRecord: 'Проверить выбранные данные?',
  IsApproveRecords: 'Проверить выбранные данные?',
  IsBooked: 'Создать заказ?',
  IsCopy: 'Вы хотите скопировать выбранный прайс-лист?',
  IsDeleteRecord: 'Удалить выбранные данные?',
  IsDeleteRecords: 'Удалить выбранные данные?',
  IsMarkup: 'Вы действительно хотите повысить цену?',
  KPIEmail: 'Получатель отчета KPI',
  LCL: 'Консолидация',
  Lane: 'Код маршрута',
  LatestTemplateVersion: 'Последняя версия шаблона - {0}',
  Level: 'Уровень',
  LoadSucceed: 'Успешно импортировать систему! \n',
  LocalCharge: 'Локальные расходы',
  MUST_EMPTY: '{0} Строка, в зависимости от значения {2}, {1} должна быть пустой; \n',
  ManualAudit: 'Ручная проверка повышения цен',
  ECommerceFareOfflineReminder: 'Уведомление о снятии опубликованных электронных тарифов',
  ECommerceFareOfflineReminderContent: 'При утверждении электронных тарифов соответствующей судоходной компании ранее опубликованные электронные тарифы будут сняты, и утвержденные в этой партии электронные тарифы станут единственными опубликованными электронными тарифами этой судоходной компании.',
  PleaseSelectDataForTheSameTariffType: 'Пожалуйста, выберите данные одного типа тарифов',
  MarketPrice: 'Рыночная цена',
  Markup: 'Наценка',
  MarkupBy: 'Наценка в процентах',
  MarkupRate: 'Единая наценка',
  MarkupTo: 'Наценка до',
  MarkupType: 'Тип наценки',
  MaxMailPerDay: 'Максимальное количество email-уведомлений в день',
  MaxQueryCount: 'Отображаются только частичные данные, пожалуйста, добавьте фильтры для поиска!',
  MaxQueryCount2: 'Загружены только первые {0} записей. Нажмите "Просмотр" для завершения поиска или "Ещё" для продолжения. Максимум 10000 цен. Сузьте критерии поиска.',
  Measurement: 'Размер',
  MinCharge: 'МИНИМУМ',
  MinimumInvalidLCL: 'Минимальная цена не может превышать весовую или объемную ставку',
  MinimumPrice: 'Минимальная цена',
  ModifiedBy: 'Изменил',
  ModifiedDate: 'Дата изменения',
  Mon: 'Понедельник',
  Monday: 'Понедельник',
  Month: 'Месяц',
  MoreSetting: 'Расширенные настройки',
  MustDifferent: '{0} и {1} не должны совпадать!',
  NA: 'Н/Д',
  NOT_ALLOWED_NEGATIVE: '{0} Строка, {1} не может быть меньше 0; \n',
  NOT_ALLOWED_UPLOAD: 'Не допускается загрузка тарифа {0}; \n',
  NO_CONFIGURATION_CHARGES: 'Сервер не настроен Дополнительная плата {0}, свяжитесь с системным администратором; \n',
  NO_FIELD: 'Отсутствие {0} в таблице; \n',
  NO_OF: '{0} Строка, в таблице отсутствует OF типа ящика {1}; \ n',
  NO_SUM: '{0} Строка, SUM типа ящика {1} является обязательным; \n',
  NStep: 'Уровень N',
  NaCode: 'NAC',
  NeedCheckApproveCfg: '0 - система не проверяет наличие неотсмотренных тарифов, 1 - автоматическая проверка.',
  NeedCheckValidityCfg: '0 - без проверки действительности тарифов перед утверждением, 1 - с проверкой.',
  NeedMarkupCfg: '0 - без послойного формирования тарифов после утверждения, 1 - с формированием.',
  NetConnectionFailed: 'Система не подключена к серверу, запрос не отправлен.',
  NewRate: 'Добавить тариф',
  Next: 'Далее',
  No: 'Нет',
  NoChargeAndPrice: 'Введите информацию о ценах или расходах.',
  NoExchangeRate: 'В системе не поддерживается курс {0}.',
  NoHit: 'Совпадений не найдено!',
  NoLabel: 'Ещё',
  NoPODCharge: 'Нет данных о сборах в порту назначения!',
  NoRecord: 'Нет данных.',
  TariffTableExportLevelTitleTips: 'Подсказка при экспорте тарифов',
  TariffTableExportLevelTips: 'Идет экспорт тарифов [Уровень: {0}].',
  PleaseSelectTheExpirationDateFirst: 'Сначала выберите срок действия.',
  EitherETDOrValidityPeriodMustBeFilledIn: 'Обязательно укажите либо ETD, либо срок действия',
  theSelectedValidityPeriodCannotExceed3Months: 'Выбранный период действия не должен превышать 3 месяцев.',
  theSelectedETDCannotExceed3Months: 'Выбранный период ETD не должен превышать 3 месяцев.',
  NoRecordSelect: 'Данные не выбраны!',
  NoRecordUpload: 'В таблице не найдены тарифы для загрузки!',
  NoSetting: 'Добавьте конфигурацию PFMarkupSetting на странице настроек.',
  NoSettingSelect: 'Отметьте пункты конфигурации!',
  NoSurcharge: 'Сбор {0} не найден.',
  NoTax: 'Все цены указаны без учета налогов, окончательная налоговая ставка определяется перевозчиком.',
  NoTierChange: 'Тарифный класс не изменился.',
  NotAccepted: 'Ожидает принятия',
  NotAllowed: 'У вас нет доступа к тарифам этого класса.',
  NotAllowedCopy: 'Вам запрещено копировать чужие коммерческие предложения.',
  NotAllowedDelete: 'Вы не можете удалять тарифы, введенные другими пользователями!',
  NotAllowedDifferentCarrierAndRegion: 'Тариф включает несколько судоходных компаний и {0}, проверка запрещена!',
  NotAllowedDifferentCarrierAndRegions: 'Тариф включает несколько судоходных компаний, регионов отправки и выгрузки, проверка запрещена!',
  NotAllowedDifferentRegions: 'Тариф включает несколько {0}, проверка запрещена!',
  NotAllowedFromCountry: 'Вам запрещено просматривать тарифы портов отправления в этой стране!',
  NotAllowedFromRegion: 'Вам запрещено просматривать тарифы портов отправления в этом регионе!',
  NotAllowedInput: 'У вас нет прав на добавление этого порта отправления.',
  NotAllowedPOD: 'Вам запрещено просматривать тарифы этого порта назначения!',
  NotAllowedPOL: 'Вам запрещено просматривать тарифы этого порта отправления!',
  NotAllowedPOD2: 'Вам запрещено просматривать тарифы порта назначения ({0})!',
  NotAllowedPOL2: 'Вам запрещено просматривать тарифы порта отправления ({0})!',
  NotAllowedToCountry: 'Вам запрещено просматривать тарифы портов назначения в этой стране!',
  NotAllowedToRegion: 'Вам запрещено просматривать тарифы портов назначения в этом регионе!',
  NotAuth: 'У вас недостаточно прав.',
  NotCheck: 'Ожидает проверки',
  NotQuotationToOthers: 'Пожалуйста, не делайте предложения клиентам других продавцов.',
  NotRequired: 'Не устанавливать',
  NotSameLength: 'Количество {0} и {1} не совпадает.',
  NotSave: 'Ваши изменения не сохранены. Сохранить?',
  Num: 'Количество',
  Num20: 'Количество 20\'',
  Num40: 'Количество 40\'',
  Num45: 'Количество 45\'',
  NumHC: 'Количество 40\'HC',
  OK: 'Подтвердить',
  Origin: 'Порт отправления',
  OtherInfo: 'Другая информация',
  FreeContainerPeriod: 'Свободные дни контейнера',
  OvertimeApprove: 'Напоминание о просрочке',
  Owner: 'Ответственный продавец',
  POD: 'Порт назначения',
  PODCharge: 'Сборы порта назначения',
  PODCity: 'Город назначения',
  PODCityPrompt: 'Введите город назначения',
  PODCodeChanged: 'Код порта выгрузки не соответствует данным в системе, возможно, этот тариф устарел!',
  PODCountry: 'Страна (регион) порта назначения',
  PODIsNull: 'Введите порт выгрузки!',
  PODPrompt: 'Введите порт выгрузки',
  PODs: 'Несколько портов назначения',
  POL: 'Порт отправления',
  POLCity: 'Город отправления',
  POLCityPrompt: 'Введите город отправления',
  POLIsNull: 'Введите порт отправления!',
  POLPrompt: 'Введите порт отправления',
  PODPrompt2: 'Введите порт назначения',
  POLs: 'Несколько портов отправления',
  PasteQuotation: 'Вставить коммерческое предложение',
  PasteSetting: 'Вставить конфигурацию',
  PaymentTerm: 'Условия оплаты',
  PendingPrice: 'На проверке',
  Phone: 'Телефон',
  PlaceAbnormal: 'Обнаружены аномалии при сравнении цен для одинаковых типов контейнеров в POL и POD',
  PlaceOfDelivery: 'Место доставки',
  PlaceOfReceipt: 'Место получения',
  PleaseSelectBookingAgent: 'Выберите агента',
  PlsChangeSystemCfg: 'Измените настройки по умолчанию на странице конфигурации системы и активируйте необходимые параметры.',
  PlsConfigDetail: 'Подробно укажите условия подписки!',
  PlsInput: 'Введите {0}.',
  PlsInputClient: 'Введите информацию о клиенте.',
  PlsInputCode: 'Введите полное название компании или код получателя!',
  PlsInputPOLPOD: 'Укажите порт отправления и порт выгрузки на странице "Основная информация"!',
  PlsInputPersonalInfo: 'Контактное лицо и телефон клиента не могут быть пустыми!',
  PlsInputQuotationNo: 'Введите номер коммерческого предложения',
  PlsInputRemark: 'Введите примечание',
  PlsInputUserInfo: 'Заполните личные данные полностью.',
  PlsSelect: 'Выберите',
  PlsSelectOF: 'Выберите тарифную информацию для расчета морского фрахта.',
  PlsSelectOffice: 'Выберите (филиал) компании, на который хотите подписаться:',
  PlsSelectRecord: 'Выберите запись!',
  PlsSelectRejectEQ: 'Выберите типы контейнеров для отказа',
  PlsSelectRule: 'Выберите правило наценки!',
  PlsSelectTenant: 'Выберите партнеров, на которых хотите подписаться:',
  PlsSelectValue: 'Сделайте выбор!',
  PlsSetEmail: 'Укажите email для получения подписки:',
  PlsSubscribe: 'Подпишитесь на интересующую вас информацию, и вы будете получать уведомления по email при обновлении тарифов.',
  PodRegion: 'Район порта назначения',
  Port: 'Порт',
  PortPrompt: 'Введите порт',
  Prepaid: 'Предоплата',
  PriceDateType: 'Базис срока действия',
  volumeWeightRatio: 'Объемно-весовое соотношение',
  minRateValue: 'Минимальная единица тарификации',
  PleaseNumber: 'Введите число',
  F: 'Срок действия считается с момента погрузки на баржу',
  M: 'Срок действия считается с момента погрузки на судно',
  PriceInfo: 'Тарифная информация',
  PriceLoadFailed: 'Не удалось загрузить тарифы!',
  PriceNo: 'Номер тарифа',
  PriceNoIsNull: 'Введите номер тарифной декларации!',
  PriceNoPrompt: 'Введите номер тарифной декларации или последние 7 цифр',
  PriceSetting: 'Настройка тарифов',
  PriceState: 'Статус тарифа',
  PriceState_Common: 'Нормальный',
  PriceState_Inquiry: 'Запрос цены',
  PriceState_Lack: 'Напряженный',
  PriceState_Overbooked: 'Перегрузка',
  PriceState_Reject: 'Не принимать',
  PriceState_Suspend: 'Отмена рейса',
  PriceTrend: 'Тенденция цен',
  Print: 'Печать',
  Query: 'Поиск',
  QueryRecords: 'Найдено {0} записей.',
  Quotation: 'Котировка',
  QuotationClient: 'Временный клиент',
  QuotationDate: 'Время котировки',
  QuotationNo: 'Номер котировки',
  QuotationValidFrom: 'Срок действия котировки',
  RATE_TYPE_ERROR: '{0} строка, {1} неверна, загруженный файл Excel отличается от текущего типа тарифа страницы или загруженный тариф Excel не является последним шаблоном; \n',
  REGION_NO_POD: '{0} Строка, область, к которой принадлежит POD {1}, не соответствует зоне разгрузки (ROD) в таблице; \n',
  REGION_NO_POL: '{0} Строка, область, к которой принадлежит POL {1}, не соответствует зоне отправления (ROL) в таблице; \n',
  ROD: 'Регион назначения',
  ROD_EQ: 'Регион выгрузки или тип контейнера',
  ROL: 'Регион отправления',
  Rate: 'Тариф',
  RateByCost: 'Себестоимость тарифа',
  RateDetails: 'Детали фрахта',
  RateGrade: 'Уровень тарифа',
  RateValidation: 'Проверка действительности тарифа',
  ReallyWantAccept: 'Вы уверены, что хотите принять тариф, которым поделился {0}?',
  ReallyWantAgree: 'Вы уверены, что хотите одобрить тариф, запрошенный {0}?',
  ReallyWantCancelAccept: 'Вы действительно хотите отменить просмотр тарифа, которым поделился {0}?',
  ReallyWantCancelShare: 'Вы действительно хотите прекратить делиться тарифом с {0}?',
  ReallyWantChange: 'Вы уверены, что хотите изменить уровень тарифа на {0}?',
  ReallyWantRefuse: 'Вы уверены, что хотите отклонить тариф, запрошенный {0}?',
  ReallyWantShare: 'Вы уверены, что хотите поделиться тарифом с {0}?',
  ReceivingInstructions: 'Особые указания по приему груза',
  ReceivingType: 'Тип особых указаний по приему груза',
  Records: 'В таблице {0} {1} записей,',
  Refresh: 'Обновить',
  RefreshFinished: 'Обновление завершено',
  Refuse: 'Отклонить запрос',
  RefuseRemark: 'Причина отказа',
  Refused: 'Отклонено',
  Region: 'Регион',
  RegionOrCarrier: 'Регион или судоходная компания',
  RejectRate: 'Цены с зачеркиванием находятся в статусе отказа, будьте осторожны!',
  RemarkAreaToolTip: 'Двойной щелчок для увеличения, еще раз для восстановления.',
  Remarks: 'Примечание',
  ECommerceRemarks: 'Примечание к электронной цене',
  TraditionalRemarks: 'Примечание к оффлайн-цене',
  RemoteBooking: 'Новая заявка',
  Reset: 'Сброс',
  Rise: 'Подъем',
  Route: 'Регион',
  RouteAndPODEmpty: 'Маршрут и порт выгрузки не могут быть пустыми одновременно!',
  RouteAndPODEmpty1: 'Убедитесь, что заполнены хотя бы один из следующих пунктов: порт отправления, порт назначения, маршрут, судоходная компания (авиакомпания), агент по бронированию (источник тарифа).',
  RouteAndPODEmpty2: 'Убедитесь, что заполнены хотя бы один из следующих пунктов: порт отправления, порт назначения, маршрут.',
  SELL_VAT: 'Налоговая ставка продажной цены',
  SUM_NOT_EQUAL: '{0} Строка, общая стоимость типа ящика {1} не равна сумме каждой дополнительной платы; \n',
  SaleState: 'Статус специального предложения',
  Sales: 'Продажа',
  Sat: 'Суббота',
  Saturday: 'Суббота',
  Save: 'Сохранить',
  SaveQuotation: 'Пожалуйста, сначала сохраните коммерческое предложение!',
  SavedSucceed: 'Сохранено.',
  ApplyAgree: 'Проверка одобрена и вступила в силу',
  ApplyRefuse: 'Проверка отклонена и вступила в силу',
  CancelAgreed: 'Отмена одобрена и вступила в силу',
  ScheduleDetails: 'Расписание судов',
  ScheduleInfo: 'Информация о расписании судов',
  SchemeAudit: 'Проверка наценки на предложение',
  Search: 'Поиск:',
  SelectRoute: 'Пожалуйста, выберите регион!',
  SelectTerm: 'Пожалуйста, выберите условия оплаты!',
  SelectTransportMode: 'Пожалуйста, выберите способ транспортировки!',
  Self: 'Собственный бизнес',
  Sell: 'Продажная цена',
  ServiceCode: 'Код услуги',
  ServiceMode: 'Режим обслуживания',
  Setting: 'Настройки',
  SettingDuplicate: 'Повторная настройка',
  SettingNoEQ: 'В выбранных строках отсутствует тип контейнера!',
  SettingNoRegion: 'В выбранных строках отсутствует {0}!',
  SettingOverlap: 'Выбранные две конфигурации дублируются!',
  Share: 'Совместное использование трюма',
  ShareCarriers: 'Судоходная компания совместного использования трюма',
  ShareRemark: 'Инструкция по обмену',
  ShareRemarks: '※Инструкция по обмену видна обеим сторонам',
  ShareState: 'Статус',
  ShareToPrompt: 'Пожалуйста, введите получателя, которому вы делитесь тарифом!',
  ShareWithMyself: 'Вам не нужно делиться тарифом с компанией, в которой вы работаете!',
  ShippingClause: 'Условия транспортировки',
  ShippingLine: 'Код внешнего порта',
  ShippingSchedule: 'Расписание судов',
  Small: 'Свернуть',
  Source: 'Источник тарифа',
  SpecialPrice: 'Специальное предложение',
  StartTime: 'Время начала',
  StatBeginDate: 'Период времени',
  StatBeginDateByDate: 'Период вв.',
  StatBeginDateByPort: 'Период д.',
  StatEndDate: 'До',
  StatSucceed: 'Операция успешно выполнена!',
  State: 'Ста. тар.',
  Statistics: 'Статистика',
  SubContractNo: 'КОД',
  SubmittedBy: 'Отправитель',
  SubmittedDate: 'Время отправки',
  Subscribe: 'Подписка',
  SubscribeCondition: 'Условия подписки',
  SubscribeFromTenant: 'Tenant подписчика',
  SubscribePOD: 'Порт выгрузки',
  SubscribePOL: 'Порт отправления',
  SubscribeType: 'Тип подписки',
  Subscriber: 'Подписчик',
  Sum: 'Итоговая стоимость',
  SumAbnormal: 'Общая стоимость тарифа содержит аномалии;',
  Sun: 'Воскресенье',
  Sunday: 'Воскресенье',
  Surcharge: 'Дополнительный сбор',
  SurchargeLoadFailed: 'Ошибка загрузки дополнительных сборов!',
  Suspend: 'Отмена рейса',
  SuspendRate: 'Цены с серым фоном отменены!',
  SuspendSelection: 'Установить выбранную цену в статус {0}?',
  TSport: 'Транзитный порт',
  TaskStart: 'Задача проверки отправлена в фоновый режим, проверьте данные позже на вкладке опубликованных!',
  Template: 'Скачать шаблон',
  TenantPrompt: 'Введите Tenant',
  Three_BE_One: 'Тариф третьего уровня не может быть меньше тарифа первого уровня!',
  Three_BE_Two: 'Тариф третьего уровня не может быть меньше тарифа второго уровня!',
  Three_B_One: 'Тариф третьего уровня должен быть больше тарифа первого уровня!',
  Thu: 'Четверг',
  Thursday: 'Четверг',
  Times: 'раз',
  Tips: 'Подсказка',
  TotalAmount: 'Количество записей',
  TradeLane: 'Маршрут',
  TransferPort: 'Транзитный порт',
  TransportMode: 'Способ перевозки',
  Tue: 'Вторник',
  Tuesday: 'Вторник',
  Two_BE_One: 'Тариф второго уровня не может быть меньше тарифа первого уровня!',
  Two_B_One: 'Тариф второго уровня должен быть больше тарифа первого уровня!',
  UnNo: 'UNNO',
  UnitPrice: 'Цена за единицу',
  UploadFailed: 'Ошибка загрузки.',
  UploadSucceed: 'Загрузка успешна.',
  VALIDITY_ERROR: '{0} строка, {1} Введите тариф только в течение следующих двух месяцев; \n',
  VALIDITY_LESS: '{0} Строка,"{1}"Не может быть меньше"Valid fm";\n',
  VAT: 'Налоговая ставка',
  ValidAbnormal: 'Срок действия тарифа содержит аномалии;',
  Validation: 'Действительность',
  ValidityCfgLoadError: 'Ошибка загрузки данных проверки действительности тарифов!',
  VatIncluded: 'Включая налог',
  VatInvalid: 'Налоговая ставка продажной цены не может быть меньше налоговой ставки себестоимости',
  Via: 'Порт перевалки',
  View: 'Просмотр',
  Visible: 'Видимый',
  Volume: 'Объем',
  VolumeCost: 'Себестоимость объемного тарифа',
  VolumePrice: 'Объемный тариф',
  WYSIWYG: 'Что видишь, то и получаешь (WYSIWYG)',
  WantApply: 'Название стороны, подающей заявку на тариф',
  Warning: 'Предупреждение',
  Wed: 'Среда',
  Wednesday: 'Среда',
  Week: 'На этой неделе',
  Weight: 'Вес (кг)',
  WeightCost: 'Себестоимость весового тарифа',
  WeightLimitInfo: 'Информация об ограничении веса',
  WeightLimitLoadFailed: 'Ошибка загрузки информации об ограничении веса!',
  WeightPrice: 'Весовой тариф',
  WeightRule: 'Правила ограничения веса',
  Weight_LCL: 'Вес',
  Wrong: 'Неверно!',
  WrongInput: 'Ошибка ввода!',
  EtaMustBeLaterThanOrEqualToEtd: 'ETA должна быть позже или равна ETD',
  Yes: 'Да',
  YesLabel: 'Просмотр',
  amsEns: 'AMS/ENS (Автоматизированная система манифестов/Система предварительного уведомления о безопасности)',
  inviteTime: 'Дата приглашения',
  jobTypeExport: 'Экспорт',
  jobTypeImport: 'Импорт',
  overloadRemarks: 'Пояснение о превышении веса',
  quantity: 'Количество мест',
  resetDataGrid: 'Сбросить таблицу',
  selectedCount: 'В настоящее время выбрано {0} записей.',
  AcceptTenant2: 'Подписчик',
  AcceptUser2: 'Оператор подписчика',
  AcceptTime2: 'Дата вступления в силу общего тарифа',
  InviteTenant2: 'Сторона, предоставляющая доступ',
  InviteUser2: 'Оператор стороны, предоставляющей доступ',
  inviteTime2: 'Дата отправки приглашения/заявки',
  customSpecs: 'Пользовательские спецификации',
  reject: 'Отклонить',
  fclRateSearch: 'Запрос тарифа FCL (полный контейнер)',
  onlyViewAndEditCostAreAllow: 'Разрешено только просматривать и редактировать себестоимость тарифа',
  SubscribePOLType: 'Тип места отправления',
  DestinationType: 'Тип места назначения',
  Destination: 'Пункт назначения',
  OtherCharge: 'Другие расходы',
  priceNoPrompt: 'Введите номер тарифа или последние 7 цифр',
  polOrPodOrRegionOneMustBeEntered: 'Необходимо указать порт отправления, порт назначения или маршрут',
  costAndSumInvalidSave: 'Продажа меньше себестоимости \ n Подтвердить сохранность',
  pleaseChooseOtherOfficeData: 'Данные не выбраны или выбраны данные другого филиала.',
  noSelectedPrice: 'Тариф не выбран.',
  BelongingCity: 'Город нахождения',
  UpdateQuotationValidity: 'Обновить дату истечения срока действия коммерческого предложения в соответствии со сроком действия тарифа?',
  CheckQuotationDeleteTip: 'Удаление коммерческого предложения, по которому уже создан заказ, запрещено!',
  PlsSelectAirOF: 'Пожалуйста, выберите один тариф в качестве авиафрахта.',
  NotMatchChargeItem: 'Не найдено соответствующего названия расхода ({0}), пожалуйста, укажите код платформы 【{1}】 в модуле тарификации!',
  AirFreight: 'Авиафрахт',
  WarExpenses: 'Военный сбор',
  FuelSurcharge: 'Топливная надбавка',
  WarehousingFee: 'Складской сбор',
  SeaFreight: 'Морской фрахт',
  QuotationWeightAndCubageLessZero: 'Вес и объем в коммерческом предложении не могут быть меньше 0!',
  Name: 'Наименование',
  MatchType: 'Способ сопоставления',
  PriceType: 'Тип тарифа',
  priceNature: 'Характер грузовой цены',
  TraditionalFreightRates: 'Оффлайн-тариф',
  Traditional: 'Оффлайн',
  ECommerce: 'Электронная коммерция',
  SpotFreightRates: 'Тариф для электронной коммерции',
  ConfigureTheSurcharge: 'Настройка дополнительных сборов',
  ConfigureTheSurchargeTips: 'Можно настроить отображение дополнительных сборов в списке',
  SpotContainerWeightTips: 'Вес контейнера по умолчанию для тарифа электронной коммерции: 18 000 кг',
  TariffTableExportExcelTips: 'Из-за объема данных рекомендуется сначала выбрать срок действия, при этом временной промежуток не должен превышать 3 месяцев',
  PolCountry: 'Страна порта отправления',
  PolRegion: 'Регион порта отправления',
  PodCountry: 'Страна порта назначения',
  PriceProfile: 'Информация о стратегии',
  SharingProfile: 'Стратегия обмена',
  SelectProfile: 'Выб. страт.',
  ViewProfile: 'Просмотр стратегии',
  PodCity: 'Город порта назначения',
  weightVolume: 'Удельный вес груза',
  DestinationAgent: 'Агент в порту назначения',
  warehouse: 'Склад',
  WarehouseName: 'Название склада',
  WarehouseAddress: 'Адрес склада',
  WarehouseMap: 'Карта склада',
  warehouseContact: 'Контактное лицо склада',
  FlightInformationManagement: 'Управление информацией о рейсах',
  FlightNo: 'Номер рейса',
  ClosingTime: 'Время закрытия приема заказов',
  DepartureTime: 'Время вылета',
  ArrivalTime: 'Время прибытия',
  SizeLimit: 'Ограничения по габаритам',
  SingletonWeightLimit: 'Ограничение веса одного места',
  ChemicalPkggReq: 'Требования к упаковке химикатов',
  LithiumBatteryReq: 'Требования к литиевым батареям',
  TimeWarning: 'Время прибытия должно быть позже времени вылета',
  AirDay: 'Количество дней',
  flightNumber: 'Номер рейса не может быть пустым',
  emptyTime: 'Здесь указано местное время.',
  BatchImportQuotations: 'Массовый импорт коммерческих предложений',
  XSuccessfulXFailed: 'Успешно: {0}, неудачно: {1}!',
  ErrorVolumeWeightRatio: 'Ошибка ввода объемного веса!',
  AirPriceServiceItem: 'Ошибка импорта: в услугах авиаперевозки нет данных. Пожалуйста, сначала внесите данные.',
  HsCode: 'Код HS'
}

